import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
import Player from '../sub-components/player.vue';
import MyBox from '../sub-components/box.vue';
import MyButton from '../sub-components/my-button.vue';
import PlayerPopup from '../sub-components/player-popup.vue';
import { logger } from '@/utils/logger';
import { isInApp, useBridge } from '@/utils/yoda';
export default defineComponent({
  components: {
    Player: Player,
    MyBox: MyBox,
    MyButton: MyButton,
    PlayerPopup: PlayerPopup
  },
  props: {
    displayedUsers: {
      type: Array,
      required: true
    }
  },
  emits: ['change-players'],
  setup: function setup(props, ctx) {
    // 用于弹窗用
    var currentPopupUser = ref(null);

    var showUserPopup = function showUserPopup(currentUser) {
      currentPopupUser.value = currentUser;
      logger.kwailog.sendClick({
        action: 'VIEW_VIDEO_BUTTON'
      });
    };

    onMounted(function () {
      logger.kwailog.sendShow({
        action: 'VIEW_VIDEO_BUTTON'
      });
    }); // 这里保存，而不是修改原始的displayedUsers.following,因为传到上面太多层级了

    var followUserMap = ref({});

    var changeUserFollow = function changeUserFollow(userId, following) {
      ctx.root.$set(followUserMap.value, userId, following);
    }; // 获取真正的用户关注情况


    var getUserFollowing = function getUserFollowing(user) {
      if (followUserMap.value[user.userId] === true || followUserMap.value[user.userId] === false) {
        return followUserMap.value[user.userId];
      }

      return user.following;
    };

    var currentPopupUserFollowing = computed(function () {
      if (!currentPopupUser.value) {
        return false;
      }

      return getUserFollowing(currentPopupUser.value);
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var namespace, canuseRes;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (isInApp) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return yoda.ready();

            case 4:
              namespace = 'business'; // 老版本兼容

              _context2.next = 7;
              return yoda.tool.canIUse({
                namespace: namespace,
                name: 'reqeustFollowStatus'
              });

            case 7:
              canuseRes = _context2.sent;

              if (!canuseRes.canUse) {
                namespace = 'bussiness';
              }

              yoda.event.addEventListener('resume', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var res;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!currentPopupUser.value) {
                          _context.next = 5;
                          break;
                        }

                        _context.next = 3;
                        return useBridge(namespace, 'reqeustFollowStatus', {
                          userIdToQuery: currentPopupUser.value.userId
                        });

                      case 3:
                        res = _context.sent;

                        if (res.result === 1) {
                          changeUserFollow(currentPopupUser.value.userId, res.followStatus === 1);
                        }

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    logger.kwailog.sendShow({
      action: 'CREATOR_REFRESH_BUTTON'
    });

    var handleChangePlayers = function handleChangePlayers() {
      logger.kwailog.sendClick({
        action: 'CREATOR_REFRESH_BUTTON'
      });
      ctx.emit('change-players');
    };

    return {
      showUserPopup: showUserPopup,
      currentPopupUser: currentPopupUser,
      changeUserFollow: changeUserFollow,
      currentPopupUserFollowing: currentPopupUserFollowing,
      handleChangePlayers: handleChangePlayers
    };
  }
});